<template>
  <div>
    <!-- Adds Theme Variables in the :root CSS -->
    <!-- <component :is="theme" /> -->

    <router-view />

    <!-- Common Message -->
    <message />

    <!-- Update Message -->
    <update-available />
  </div>
</template>

<script>
import Message from '@/components/Message'
import UpdateAvailable from '@/components/UpdateAvailable'

export default {
  components: {
    Message,
    UpdateAvailable
  }
}
</script>
